import clsx from 'clsx';
import PropTypes from 'prop-types';
import React, { useEffect, useRef, useState } from 'react';

import { MAIN_CONTENT_ID } from './constants';

const LayoutHeader = ({ header, children, contentRef, footer, imageBackground, textInImageBackground, courseGradient, className, style, isMainLandmark = true }) => {
  const headerRef = useRef(null);
  const [headerHeight, setHeaderHeight] = useState(null);

  useEffect(() => {
    if (!header || !headerRef.current || typeof ResizeObserver === 'undefined') {
      return undefined;
    }

    const updateHeaderHeight = () => setHeaderHeight(headerRef.current.offsetHeight);
    updateHeaderHeight();

    const resizeObserver = new ResizeObserver(updateHeaderHeight);
    resizeObserver.observe(headerRef.current);

    return () => resizeObserver.disconnect();
  }, [header]);

  const layoutHeaderStyle = {
    ...style,
    ...(headerHeight !== null && { '--layout-header-height': `${headerHeight}px` }),
  };

  // == Solo el shell de página emite el landmark main; anidado renderiza un div para no
  // == duplicarlo ni duplicar el id del skip link.
  const ContentTag = isMainLandmark ? 'main' : 'div';
  const mainLandmarkProps = isMainLandmark ? { id: MAIN_CONTENT_ID, tabIndex: -1 } : {};

  return (
    <div className={clsx('layout-header', className, { 'layout-header--with-footer': footer })} style={layoutHeaderStyle}>
      {header && (
        <header ref={headerRef} className="layout-header__header">
          {header}
        </header>
      )}
      {(imageBackground || courseGradient) && (
        <div className="layout-header__background-image" style={{ backgroundImage: imageBackground ? `url(${imageBackground})` : courseGradient }}>
          <div className="layout-header__background-text-container">
            <span className="layout-header__background-text">{textInImageBackground}</span>
          </div>
        </div>
      )}
      <ContentTag className="layout-header__content" ref={contentRef} {...mainLandmarkProps}>
        <div className="layout-header__children">{children}</div>
      </ContentTag>
      {footer && <div className="layout-header__footer">{footer}</div>}
    </div>
  );
};

LayoutHeader.propTypes = {
  header: PropTypes.node,
  children: PropTypes.node,
  contentRef: PropTypes.object,
  footer: PropTypes.node,
  imageBackground: PropTypes.string,
  textInImageBackground: PropTypes.node,
  courseGradient: PropTypes.string,
  className: PropTypes.string,
  style: PropTypes.object,
  isMainLandmark: PropTypes.bool,
};

export default LayoutHeader;
